import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';



ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();

// const express = require('express');
// const app = express();

// app.get('/callback', function asdf(req, res) {
// 	console.log(req.query)
// });

//https://medium.freecodecamp.org/how-to-make-create-react-app-work-with-a-node-backend-api-7c5c48acb1b0


// WEBPACK FOOTER //
// ./src/index.js